import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../shared/api/user";
import { Toast } from "../../components/Toast/Toast";

export default function ChangePasswordForm() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await changePassword(oldPassword, newPassword);
    if (res.success) {
      setToastType("success");
      setToastMessage("Пароль успешно изменён.");
      setTimeout(() => navigate("/profile"), 1500);
    } else {
      setToastType("error");
      setToastMessage(res.message || "Ошибка при смене пароля");
    }
  };

  const handleCloseToast = () => {
    setToastMessage("");
  };

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="max-w-md mt-5 mx-auto p-4 bg-white rounded shadow"
      >
        <h2 className="text-xl font-semibold mb-4 text-center">Изменение пароля</h2>

        <label className="block mb-2 text-[16px]">
          Старый пароль:
          <input
            type="password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            required
            className="mt-1 p-2 w-full border rounded-lg text-[16px]"
          />
        </label>

        <label className="block mb-4 text-[16px]">
          Новый пароль:
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            className="mt-1 p-2 w-full border rounded-lg text-[16px]"
          />
        </label>

        <div className="flex gap-2">
          <button
            type="submit"
            className="bg-blue-600  text-white px-4 py-1 rounded-lg text-[16px] w-full hover:bg-blue-700"
          >
            Сменить пароль
          </button>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="border-blue-600 border-2 text-blue-600 px-4 py-1 rounded-lg text-[16px] w-full hover:bg-blue-700 hover:border-blue-700 hover:text-white"
          >
            Назад
          </button>
        </div>
      </form>

      <Toast message={toastMessage} type={toastType} onClose={handleCloseToast} />
    </>
  );
}
